import { Product } from "./product.model";

export class GroupProduct {

    public groupId: number;
    public productId: number;
    public product: Product;
    public groupProductId: number;

    public constructor(init?: Partial<GroupProduct>) {
        Object.assign(this, init);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/group-product.model.ts